export default __webpack_public_path__ + "static/media/pie_chart.1fb0798a.svg";